import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'cityPass';

// Action Types
export const types = {
  VALIDATE_TICKET: createAsyncTypes(`${KEY}/VALIDATE_TICKET`),
  REMOVE_TICKET: `${KEY}/REMOVE_TICKET`,
  RESET_CITY_PASS: `${KEY}/RESET_CITY_PASS`,
  RESET_ACTION: `${KEY}/RESET_ACTION`,
  SET_WAS_AUTO_RESERVE_TRIGGERED: `${KEY}/SET_WAS_AUTO_RESERVE_TRIGGERED`
};

export interface CityPassTicket {
  barcode: string;
  classId: number;
  className: string;
  productFamilyName: string;
}

export interface CityPassState {
  readonly tickets: CityPassTicket[];
  readonly action: {
    readonly loading: boolean;
    readonly success: boolean;
    readonly error: undefined | string;
  };
  readonly wasAutoReserveTriggered: boolean;
}

/** Data provided to the BE to indicate CP flow */
export interface CityPassParams {
  readonly tickets: CityPassTicket[];
}

export interface ValidateTicketRequest {
  type: typeof types.VALIDATE_TICKET.REQUEST;
  payload: string;
}

export interface ValidateTicketResponse {
  type: typeof types.VALIDATE_TICKET.SUCCESS;
  payload: CityPassTicket;
}

export interface ValidateTicketPending {
  type: typeof types.VALIDATE_TICKET.PENDING;
  payload: boolean;
}

export interface ValidateTicketError {
  type: typeof types.VALIDATE_TICKET.ERROR;
  payload: string;
}

export interface ResetAction {
  type: typeof types.RESET_ACTION;
}

export interface SetWasAutoReserveTriggered {
  type: typeof types.SET_WAS_AUTO_RESERVE_TRIGGERED;
  payload: boolean;
}

export type CityPassActionTypes =
  | ValidateTicketRequest
  | ValidateTicketResponse
  | ValidateTicketPending
  | ValidateTicketError
  | ResetAction
  | SetWasAutoReserveTriggered;
